import { createAsyncAction } from "../../utils/actionCreators";

export const types = {
  PROCESSAR: "@@geracao-os/PROCESSAR",
};

export const actions = {
  processar: createAsyncAction(types.PROCESSAR),
};
